import i18next from 'i18next';
import { Trans, useTranslation } from 'react-i18next';

import ListOfIcons from '../../ListWithIcon/ListWithIcons';
import * as Styled from '../Styles.styles';

function PrivacyGuidelines() {
  const { t } = useTranslation();

  const conductPoints = t('privacyPolicy.codeOfConductHudd.list', {
    returnObjects: true,
  });
  const guidelinesForCompanyProfiles = t(
    'privacyPolicy.guidelinesForCompanyProfiles.list',
    {
      returnObjects: true,
    },
  );

  return (
    <div className="page">
      <Styled.PageTitle>{t('privacyPolicy.title')}</Styled.PageTitle>
      <Styled.SectionTerms className="section-terms" withoutBottomRadius>
        <Styled.About className="about">
          <p>
            <Trans
              i18nKey={t('privacyPolicy.date')}
              components={{
                span: <span className="date" />,
              }}
            />
          </p>
          <p>{t('privacyPolicy.textUnderDate')}</p>
        </Styled.About>

        <Styled.PrivacyTable>
          <tbody>
            <tr>
              <th>
                <Styled.PrivacySectionTitle component="p">
                  {t('privacyPolicy.items.1.title')}
                </Styled.PrivacySectionTitle>
              </th>
              <td>
                <p>
                  <b>{t('privacyPolicy.items.1.listTitle')}</b>
                </p>
                <ol>
                  <li>{t('privacyPolicy.items.1.listItems.1')}</li>
                  <li>{t('privacyPolicy.items.1.listItems.2')}</li>
                  <li>{t('privacyPolicy.items.1.listItems.3')}</li>
                </ol>
                <p>{t('privacyPolicy.items.1.text')}</p>
              </td>
            </tr>
            <tr>
              <th>
                <Styled.PrivacySectionTitle component="p">
                  {t('privacyPolicy.items.2.title')}
                </Styled.PrivacySectionTitle>
              </th>
              <td>
                <p>
                  <b>{t('privacyPolicy.items.2.listTitle')}</b>
                </p>
                <ol>
                  <li>{t('privacyPolicy.items.2.listItems.1')}</li>
                  <li>{t('privacyPolicy.items.2.listItems.2')}</li>
                  <li>{t('privacyPolicy.items.2.listItems.3')}</li>
                  <li>{t('privacyPolicy.items.2.listItems.4')}</li>
                  <li>{t('privacyPolicy.items.2.listItems.5')}</li>
                </ol>
                <p>{t('privacyPolicy.items.2.text')}</p>
              </td>
            </tr>
            <tr>
              <th>
                <Styled.PrivacySectionTitle component="p">
                  {t('privacyPolicy.items.3.title')}
                </Styled.PrivacySectionTitle>
              </th>
              <td>
                <p>
                  <b>{t('privacyPolicy.items.3.listTitle')}</b>
                </p>
                <ol>
                  <li>{t('privacyPolicy.items.3.listItems.1')}</li>
                  <li>{t('privacyPolicy.items.3.listItems.2')}</li>
                  <li>{t('privacyPolicy.items.3.listItems.3')}</li>
                </ol>
              </td>
            </tr>
            <tr>
              <th>
                <Styled.PrivacySectionTitle component="p">
                  {t('privacyPolicy.items.4.title')}
                </Styled.PrivacySectionTitle>
              </th>
              <td>
                <p>{t('privacyPolicy.items.4.text')}</p>
                {t('privacyPolicy.items.4.bottomText')}
              </td>
            </tr>
            <tr>
              <th>
                <Styled.PrivacySectionTitle component="p">
                  {t('privacyPolicy.items.5.title')}
                </Styled.PrivacySectionTitle>
              </th>
              <td>
                <p>{t('privacyPolicy.items.5.text')}</p>
              </td>
            </tr>
            <tr>
              <th>
                <Styled.PrivacySectionTitle component="p">
                  {t('privacyPolicy.items.6.title')}
                </Styled.PrivacySectionTitle>
              </th>
              <td>
                <p>{t('privacyPolicy.items.6.text')}</p>
              </td>
            </tr>
            <tr>
              <th>
                <Styled.PrivacySectionTitle component="p">
                  {t('privacyPolicy.items.7.title')}
                </Styled.PrivacySectionTitle>
              </th>
              <td>
                <p>{t('privacyPolicy.items.7.text')}</p>
              </td>
            </tr>
            <tr>
              <th>
                <Styled.PrivacySectionTitle component="p">
                  {t('privacyPolicy.items.8.title')}
                </Styled.PrivacySectionTitle>
              </th>
              <td>
                <p>
                  <Trans
                    i18nKey={t('privacyPolicy.items.8.text')}
                    components={{
                      br: <br />,
                      email: (
                        <a
                          href={`mailto:legal@hudd.${i18next.language === 'sv' ? 'se' : i18next.language}`}
                          rel="noreferrer"
                        />
                      ),
                      a: (
                        <a
                          href="https://www.Datatilsynet.no"
                          rel="noreferrer"
                        />
                      ),
                    }}
                  />
                </p>
              </td>
            </tr>
          </tbody>
        </Styled.PrivacyTable>

        <p>{t('privacyPolicy.bottomText')}</p>

        <Styled.Link href="/" rel="noreferrer">
          <Styled.LinksIcon variant="documentAdd" size="sm" />
          {t('privacyPolicy.link')}
        </Styled.Link>
      </Styled.SectionTerms>
      <div
        className={`section-conduct ${i18next.language != 'no' && 'with-border-radius'}`}
      >
        <ListOfIcons
          isIndividualElements
          data={conductPoints}
          title={t('privacyPolicy.codeOfConductHudd.title')}
        />
      </div>
      {i18next.language === 'no' && (
        <div className="section-conduct with-border-radius">
          <ListOfIcons
            data={guidelinesForCompanyProfiles}
            title={t('privacyPolicy.guidelinesForCompanyProfiles.title')}
          />
        </div>
      )}
    </div>
  );
}

export default PrivacyGuidelines;
